import { useState } from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import "./public-layout.css";
import { Slide } from "@mui/material";
import { getRoutePathname } from "../../Handler/RouteHandler";
import { useNavigate } from "react-router-dom";

function PublicLayout(props) {
  const navigate = useNavigate();
  // SUPER VISION
  const [countSuperVision, setCountSuperVision] = useState(0);
  const [isSuperVision, setIsSuperVision] = useState(false);
  const superVision = () => {
    let count = countSuperVision + 1;
    if (count === 1) {
      setTimeout(() => {
        setCountSuperVision(0);
      }, 2000);
    }
    if (count === 3) {
      setIsSuperVision(!isSuperVision);
      setCountSuperVision(0);
    } else {
      setCountSuperVision(count);
    }
  };

  return (
    <div className="public-layout-shell">
      <header className="public-hero">
        <div className="public-hero-top">
          <p className="public-hero-overline">Institut expert visage</p>
        </div>

        <h1>Soins du visage <br />à Aix-en-Provence</h1>

        <p className="public-hero-tags">
          Corneotherapie <span>&bull;</span> Facialisme <span>&bull;</span> Technologies
        </p>
      </header>

      <main className="public-layout-main">
        {props.view && <props.view />}
      </main>

      <footer className="public-footer">
        <section className="public-footer-col public-footer-center">
          <img onClick={superVision} src="/asset/image/logo.webp" alt="Inoutskin" className="public-footer-logo" />
          <Slide direction="left" in={isSuperVision} style={{ transitionDelay: '0ms' }} {...{ timeout: 500 }}>
            <div hidden={!isSuperVision} onClick={() => {navigate(getRoutePathname('authentication_admin'));}} style={{
              background: '#c0a58e',
              padding: 5,
              color: '#FFF',
              borderRadius: 5,
              cursor: 'pointer'
            }}>Admin
            </div>
          </Slide>
          <p>Institut expert visage</p>
          <div className="public-footer-socials">
            <a
              href="https://www.facebook.com/share/1AdHraXP3e/"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
            >
              <FacebookIcon fontSize="inherit" />
            </a>
            <a
              href="https://www.instagram.com/inout_skin?igsh=MTFmZTZzdWt5ZGFheg=="
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <InstagramIcon fontSize="inherit" />
            </a>
          </div>
        </section>
      </footer>

    </div>
  );
}

export default PublicLayout;
